import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { Table, Icon, Label } from 'semantic-ui-react'
import { Pagination, SortIcon } from '../components'
import { roles } from '../../common/config'

const { Header, Body, Row, Cell, HeaderCell, Footer } = Table

const sortIcons = {
  ascending: <SortIcon ascending />,
  descending: <SortIcon descending />,
  sort: <SortIcon />,
}

const getDriverActive = (result) => {
  if (result.state == 'ARCHIV')
    return <Icon name="remove user" color="red" size="large" />
  else if(result.state == 'HOME')
    return <Icon name="ban" color="red" size="large" />
  else if(result.state == 'IDLE')
    return <Icon name="home" color="red" size="large" />

  if (result.archived) {
    return <Icon name="remove user" color="red" size="large" />
  } else {
    return <Icon name="user" color="green" size="large" />
  }
}

const getBirthDate = (date) => {
  var m = moment('' + date);
  if (m.isValid()) {
    if (m.isAfter('1901-05-01')) { /* 2. května 1901 - Chiyo Miyako */
      return m.format('D.M.YYYY') + ' (' + moment().diff(m, 'years') + ')'
    } else {
      return '-'
    }
  } else {
    return '.'
  }
}

const DriversTable = ({
  drivers, meta, list, role, waitingForDownload, getCSV, csv, clearDownload
}) => {
  const paging = list.$paging(meta.count)
  return (
    <Table className="drivers">
      <Header>
        <Row>
		  <HeaderCell />
          <HeaderCell>{list.$heading('lastNameSort', 'Přijmení', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('firstNameSort', 'Jméno', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('birthdate', 'Datum narození', sortIcons)}</HeaderCell>
          {[roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
            <HeaderCell>{list.$heading('companyNameSort', 'Dopravce', sortIcons)}</HeaderCell>
          }
          <HeaderCell>Pracovní poměr</HeaderCell>
          <HeaderCell />
          <HeaderCell />

          { [roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
            <HeaderCell />
          }
        </Row>
      </Header>
      <Body>
        {drivers.map((d) => (
          <Row key={d._id}>
			<Cell className="cell-with-icon">{getDriverActive(d)}</Cell>
            <Cell>{d.lastName}</Cell>
            <Cell>{d.firstName}</Cell>
            <Cell>{getBirthDate(d.birthdate)}</Cell>
            {[roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
              <Cell>{d.companyName}</Cell>
            }
            <Cell>{d.employmentFinished && <Label color="red" size="big">Ukončen</Label>}{d.archived && <Label color="red" size="big">Smazán</Label>}</Cell>
            <Cell>{!d.archived && <Link to={`/drivers/${d._id}`}><i className="daicon daicon-Edit" /> Upravit řidiče</Link>}</Cell>
            <Cell><Link to={`/results?driver=${d._id}`}><i className="daicon daicon-Test" /> Seznam hodnocení</Link></Cell>
            { [roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 &&
              <Cell>{!d.archived && <Link to={`/newresult/${d._id}`}><Icon name="add" /> Nové hodnocení</Link>}</Cell>
            }
          </Row>
        ))}
      </Body>
      <Footer>
        <Row>
          <Cell colSpan={[roles.SUPERVISOR, roles.ADMIN].indexOf(role) !== -1 ? 5 : 4}>
            {`
              Zobrazeno
              ${Math.min(((meta.currentPage - 1) * 100) + 1, meta.count)}
              -
              ${Math.min((meta.currentPage * 100) + 1, meta.count)} z ${meta.count}
            `}
            {(getCSV || csv) && <span>-&nbsp;</span>}
            {getCSV && !csv &&
              <span className="downloadCSV">
                {waitingForDownload
                  ? <Icon loading name="spinner" />
                  : <a onClick={getCSV}>Stáhnout CSV</a>
                }
              </span>
            }
            {csv &&
              <a href={csv} rel="noopener noreferrer" target="_blank" onClick={clearDownload}>
                CSV připraveno, klikněte pro stažení
              </a>
            }
          </Cell>
          <Cell colSpan={4}><Pagination paging={paging} /></Cell>
        </Row>
      </Footer>
    </Table>
  )
}

DriversTable.defaultProps = {
  getCSV: null,
  waitingForDownload: false,
  csv: '',
}

DriversTable.propTypes = {
  drivers: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  list: React.PropTypes.object.isRequired,
  role: React.PropTypes.string.isRequired,
  getCSV: React.PropTypes.any,
  waitingForDownload: React.PropTypes.bool,
  clearDownload: React.PropTypes.func.isRequired,
  csv: React.PropTypes.string,
}

export default DriversTable



// WEBPACK FOOTER //
// ./src/browser/tables/Drivers.js